// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-header.title::after {
  height: var(--unit-xxxsm);
  bottom: calc(var(--unit-xxxsm) * -1);
}
ion-header.title ion-title {
  color: var(--Labels-Primary, #000);
  text-align: center;
  font-family: "Poppins";
  font-size: 17px;
  font-style: normal;
  font-weight: 590;
  line-height: 22px;
  position: relative;
  top: 0px;
}
ion-header.title :host(.button-clear) {
  --color: #000 !important;
}
ion-header.title .subtitle {
  padding-inline: var(--unit-lg);
  width: 100%;
}
ion-header.title .subtitle ion-label {
  font-size: var(--font-md);
  font-weight: 400;
  --color: var(--ion-color-info-text);
}

ion-toolbar .close-icon {
  width: 32px;
  height: 32px;
}

.ios-modal ion-toolbar:first-of-type {
  padding-top: 0px !important;
}

.config-title {
  color: var(--ion-color-primary);
}

ion-header ion-toolbar {
  --background: #fff;
}
ion-header ion-toolbar ion-icon {
  margin-right: 16px;
}

ion-header.search {
  background: transparent;
  padding: var(--unit-md);
}
ion-header.search::after {
  background-image: none;
}

ion-content {
  --background: var(--ion-color-primary-contrast);
  --padding-bottom: var(--unit-xxxsm);
}

ion-footer {
  --background: transparent;
}
ion-footer ion-toolbar {
  --border-width: 0;
  --padding-end: 0;
  --padding-start: 0;
  border-top-left-radius: var(--radius-md);
  border-top-right-radius: var(--radius-md);
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);
}
ion-footer ion-grid ion-button {
  width: auto;
}

#container-actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  border-bottom: 1px solid #f0f0f0;
}
#container-actions .cancel,
#container-actions .accept {
  color: var(--ion-color-primary);
  text-align: right;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.4px;
  font-size: 14px !important;
  text-transform: initial;
}
#container-actions .title {
  color: #000 !important;
  text-align: center;
  font-family: "Poppins";
  font-size: 14px !important;
  text-transform: initial;
  font-style: normal;
  font-weight: 590;
  line-height: 18px;
}

.container-date {
  border-radius: 16px;
  border: 1px solid #f6f6f6;
  background: #FFF;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.15);
  min-height: 56px;
}

.custom-item-form {
  border-radius: 16px;
  border: 1px solid #f6f6f6;
  background: #FFF;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.15);
  margin-bottom: 16px;
  --padding-start: 16px;
  --padding-end: 16px;
}
.custom-item-form .single-p {
  color: #425F81 !important;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Roboto";
  font-size: 16px !important;
  font-weight: 400;
}
.custom-item-form .icon-select {
  width: 16px;
  height: 16px;
}
.custom-item-form ion-chip {
  border-radius: 8px;
  background: var(--Background, #F3F3F3);
  color: var(--text-BODY, #2C4051);
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.container-datetime {
  --background: #fff;
}

.no-border {
  box-shadow: none;
  border: none;
  margin-bottom: 0px;
}

.custom-item-form ::ng-deep .custom-input .label-text {
  color: #425F81 !important;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Roboto";
  font-size: 16px !important;
}
.custom-item-form ::ng-deep .custom-input {
  color: #2C4051;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding-left: 0px;
}

#historyDetail {
  padding: 0px 16px;
}
#historyDetail ion-item {
  --padding-start: 0px;
  --padding-end: 0px;
}
#historyDetail ion-item ion-label {
  margin-bottom: 8px;
  margin-top: 8px;
}
#historyDetail ion-item ion-label h2 {
  color: var(--text-Info, #788089);
  font-family: "Poppins";
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
#historyDetail ion-item ion-label p {
  color: var(--text-BODY, #2C4051);
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.container-update {
  margin-top: 30px;
  margin-bottom: 60px;
}
.container-update p {
  font-family: "Poppins";
  font-weight: 600;
}

.donut-item {
  height: 80px;
  border-radius: 16px;
  border: 2px solid #ececec;
  margin: 2px 0px 12px 0px;
  --padding-start: 0px;
  --padding-end: 16px;
}
.donut-item ion-label {
  margin: 0px;
}
.donut-item ion-thumbnail {
  margin: 0px 10px 0px 0px;
  width: 73px;
  height: 79px;
  object-fit: cover;
}
.donut-item .bg-no-image {
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  background: var(--ion-color-primary);
  color: var(--ion-color-default-text);
  font-size: 30px;
}

.donut-image img {
  border-radius: 8px 0px 8px 0px;
}

.donut-details h2 {
  color: #000;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
}

.donut-details p {
  color: var(--text-Info, #788089);
  font-family: "Poppins";
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-top: 6px;
}

.price {
  color: var(--Brand-Primario, #0554F2);
  font-family: "Poppins";
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.donut-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  background: var(--CTA-CTA-Primario, linear-gradient(180deg, #076DF2 0%, #0554F2 100%));
}
.donut-actions ion-icon {
  width: 13px;
  color: #fff;
  margin: 5px 6px;
  position: relative;
  right: 2px;
}
.donut-actions .trash {
  position: relative;
  left: 4px;
}

.add-clear {
  color: #fff;
  padding-left: 12px;
  font-feature-settings: "liga" off, "clig" off;
  font-family: Poppins;
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.add-clear ion-icon {
  padding-right: 3px;
}

.donut-quantity {
  background-color: white;
  padding: 4px 8px;
  border-radius: 4px;
  width: 24px;
  height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--text-Subtitles, #13011D);
  text-align: center;
  font-feature-settings: "liga" off, "clig" off;
  font-family: Poppins;
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}`, "",{"version":3,"sources":["webpack://./src/app/components/product-sheet/product-sheet.component.scss"],"names":[],"mappings":"AACE;EACE,yBAAA;EACA,oCAAA;AAAJ;AAGE;EACE,kCAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AADJ;AAIE;EACE,wBAAA;AAFJ;AAKE;EACE,8BAAA;EACA,WAAA;AAHJ;AAKI;EACE,yBAAA;EACA,gBAAA;EACA,mCAAA;AAHN;;AAQA;EACE,WAAA;EACA,YAAA;AALF;;AAQA;EACE,2BAAA;AALF;;AAQA;EACE,+BAAA;AALF;;AASE;EACE,kBAAA;AANJ;AAQI;EACE,kBAAA;AANN;;AAWA;EACE,uBAAA;EACA,uBAAA;AARF;AAUE;EACE,sBAAA;AARJ;;AAYA;EACE,+CAAA;EACA,mCAAA;AATF;;AAYA;EACE,yBAAA;AATF;AAWE;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,wCAAA;EACA,yCAAA;EACA,2CAAA;AATJ;AAaI;EACE,WAAA;AAXN;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,6BAAA;EACA,gCAAA;AAbF;AAeE;;EAEE,+BAAA;EACA,iBAAA;EACA,6CAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,0BAAA;EACA,uBAAA;AAbJ;AAgBE;EACE,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,0BAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAdJ;;AAkBA;EACE,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,+CAAA;EACA,gBAAA;AAfF;;AAkBA;EACE,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,+CAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;AAfF;AAiBE;EACE,yBAAA;EACA,6CAAA;EACA,qBAAA;EACA,0BAAA;EACA,gBAAA;AAfJ;AAkBE;EACE,WAAA;EACA,YAAA;AAhBJ;AAmBE;EACE,kBAAA;EACA,sCAAA;EAEA,gCAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAlBJ;;AAsBA;EACE,kBAAA;AAnBF;;AAsBA;EACE,gBAAA;EACA,YAAA;EACA,kBAAA;AAnBF;;AAuBE;EAQE,yBAAA;EACA,6CAAA;EACA,qBAAA;EACA,0BAAA;AA3BJ;AA8BE;EACE,cAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AA5BJ;;AAgCA;EACE,iBAAA;AA7BF;AA+BE;EACE,oBAAA;EACA,kBAAA;AA7BJ;AA+BI;EACE,kBAAA;EACA,eAAA;AA7BN;AA+BM;EACE,gCAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AA7BR;AAgCM;EACE,gCAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AA9BR;;AAoCA;EACE,gBAAA;EACA,mBAAA;AAjCF;AAmCE;EACE,sBAAA;EACA,gBAAA;AAjCJ;;AAqCA;EACE,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,wBAAA;EACA,oBAAA;EACA,mBAAA;AAlCF;AAoCE;EACE,WAAA;AAlCJ;AAqCE;EACE,wBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAnCJ;AAwCE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,oCAAA;EACA,oCAAA;EACA,eAAA;AAtCJ;;AA0CA;EACE,8BAAA;AAvCF;;AA0CA;EACE,WAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAvCF;;AA0CA;EACE,gCAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AAvCF;;AA0CA;EACE,qCAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAvCF;;AA0CA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,sFAAA;AAvCF;AAyCE;EACE,WAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;AAvCJ;AA0CE;EACE,kBAAA;EACA,SAAA;AAxCJ;;AA4CA;EACE,WAAA;EACA,kBAAA;EACA,6CAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAzCF;AA2CE;EACE,kBAAA;AAzCJ;;AA6CA;EACE,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,qCAAA;EACA,kBAAA;EACA,6CAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AA1CF","sourcesContent":["ion-header.title {\n  &::after {\n    height: var(--unit-xxxsm);\n    bottom: calc(var(--unit-xxxsm) * -1);\n  }\n\n  ion-title {\n    color: var(--Labels-Primary, #000);\n    text-align: center;\n    font-family: \"Poppins\";\n    font-size: 17px;\n    font-style: normal;\n    font-weight: 590;\n    line-height: 22px;\n    position: relative;\n    top: 0px;\n  }\n\n  :host(.button-clear) {\n    --color: #000 !important;\n  }\n\n  .subtitle {\n    padding-inline: var(--unit-lg);\n    width: 100%;\n\n    ion-label {\n      font-size: var(--font-md);\n      font-weight: 400;\n      --color: var(--ion-color-info-text);\n    }\n  }\n}\n\nion-toolbar .close-icon {\n  width: 32px;\n  height: 32px;\n}\n\n.ios-modal ion-toolbar:first-of-type {\n  padding-top: 0px !important;\n}\n\n.config-title {\n  color: var(--ion-color-primary);\n}\n\nion-header {\n  ion-toolbar {\n    --background: #fff;\n\n    ion-icon {\n      margin-right: 16px;\n    }\n  }\n}\n\nion-header.search {\n  background: transparent;\n  padding: var(--unit-md);\n\n  &::after {\n    background-image: none;\n  }\n}\n\nion-content {\n  --background: var(--ion-color-primary-contrast);\n  --padding-bottom: var(--unit-xxxsm);\n}\n\nion-footer {\n  --background: transparent;\n\n  ion-toolbar {\n    --border-width: 0;\n    --padding-end: 0;\n    --padding-start: 0;\n    border-top-left-radius: var(--radius-md);\n    border-top-right-radius: var(--radius-md);\n    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);\n  }\n\n  ion-grid {\n    ion-button {\n      width: auto;\n    }\n  }\n}\n\n#container-actions {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-around;\n  border-bottom: 1px solid #f0f0f0;\n\n  .cancel,\n  .accept {\n    color: var(--ion-color-primary);\n    text-align: right;\n    font-feature-settings: \"liga\" off, \"clig\" off;\n    font-family: 'Poppins';\n    font-style: normal;\n    font-weight: 400;\n    line-height: 18px;\n    letter-spacing: -0.4px;\n    font-size: 14px !important;\n    text-transform: initial;\n  }\n\n  .title {\n    color: #000 !important;\n    text-align: center;\n    font-family: \"Poppins\";\n    font-size: 14px !important;\n    text-transform: initial;\n    font-style: normal;\n    font-weight: 590;\n    line-height: 18px;\n  }\n}\n\n.container-date {\n  border-radius: 16px;\n  border: 1px solid #f6f6f6;\n  background: #FFF;\n  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.15);\n  min-height: 56px;\n}\n\n.custom-item-form {\n  border-radius: 16px;\n  border: 1px solid #f6f6f6;\n  background: #FFF;\n  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.15);\n  margin-bottom: 16px;\n  --padding-start: 16px;\n  --padding-end: 16px;\n\n  .single-p {\n    color: #425F81 !important;\n    font-feature-settings: \"liga\" off, \"clig\" off;\n    font-family: \"Roboto\";\n    font-size: 16px !important;\n    font-weight: 400;\n  }\n\n  .icon-select {\n    width: 16px;\n    height: 16px;\n  }\n\n  ion-chip {\n    border-radius: 8px;\n    background: var(--Background, #F3F3F3);\n\n    color: var(--text-BODY, #2C4051);\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-family: 'Poppins';\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n  }\n}\n\n.container-datetime {\n  --background: #fff;\n}\n\n.no-border {\n  box-shadow: none;\n  border: none;\n  margin-bottom: 0px;\n}\n\n.custom-item-form {\n  ::ng-deep .custom-input .label-text {\n    // color: var(--ion-color-primary);\n    // font-family: 'Poppins';\n    // font-size: 12px;\n    // font-style: normal;\n    // font-weight: 500;\n    // line-height: normal;\n\n    color: #425F81 !important;\n    font-feature-settings: \"liga\" off, \"clig\" off;\n    font-family: \"Roboto\";\n    font-size: 16px !important;\n  }\n\n  ::ng-deep .custom-input {\n    color: #2C4051;\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-family: 'Poppins';\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    padding-left: 0px;\n  }\n}\n\n#historyDetail {\n  padding: 0px 16px;\n\n  ion-item {\n    --padding-start: 0px;\n    --padding-end: 0px;\n\n    ion-label {\n      margin-bottom: 8px;\n      margin-top: 8px;\n\n      h2 {\n        color: var(--text-Info, #788089);\n        font-family: 'Poppins';\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: normal;\n      }\n\n      p {\n        color: var(--text-BODY, #2C4051);\n        font-feature-settings: 'liga' off, 'clig' off;\n        font-family: 'Poppins';\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: normal;\n      }\n    }\n  }\n}\n\n.container-update {\n  margin-top: 30px;\n  margin-bottom: 60px;\n\n  p {\n    font-family: 'Poppins';\n    font-weight: 600;\n  }\n}\n\n.donut-item {\n  height: 80px;\n  border-radius: 16px;\n  border: 2px solid #ececec;\n  margin: 2px 0px 12px 0px;\n  --padding-start: 0px;\n  --padding-end: 16px;\n\n  ion-label {\n    margin: 0px;\n  }\n\n  ion-thumbnail {\n    margin: 0px 10px 0px 0px;\n    width: 73px;\n    height: 79px;\n    object-fit: cover;\n\n\n  }\n\n  .bg-no-image {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-transform: uppercase;\n    background: var(--ion-color-primary);\n    color: var(--ion-color-default-text);\n    font-size: 30px;\n  }\n}\n\n.donut-image img {\n  border-radius: 8px 0px 8px 0px;\n}\n\n.donut-details h2 {\n  color: #000;\n  font-feature-settings: 'liga' off, 'clig' off;\n  font-family: 'Poppins';\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n}\n\n.donut-details p {\n  color: var(--text-Info, #788089);\n  font-family: 'Poppins';\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  margin-top: 6px;\n}\n\n.price {\n  color: var(--Brand-Primario, #0554F2);\n  font-family: 'Poppins';\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n\n.donut-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border-radius: 8px;\n  background: var(--CTA-CTA-Primario, linear-gradient(180deg, #076DF2 0%, #0554F2 100%));\n\n  ion-icon {\n    width: 13px;\n    color: #fff;\n    margin: 5px 6px;\n    position: relative;\n    right: 2px;\n  }\n\n  .trash{\n    position: relative;\n    left: 4px;\n  }\n}\n\n.add-clear {\n  color: #fff;\n  padding-left: 12px;\n  font-feature-settings: 'liga' off, 'clig' off;\n  font-family: Poppins;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n\n  ion-icon{\n    padding-right: 3px;\n  }\n}\n\n.donut-quantity {\n  background-color: white;\n  padding: 4px 8px;\n  border-radius: 4px;\n  width: 24px;\n  height: 16px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: var(--text-Subtitles, #13011D);\n  text-align: center;\n  font-feature-settings: 'liga' off, 'clig' off;\n  font-family: Poppins;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
